import { useEffect, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { t } from "../i18n";
import API from "../config";

export default function About() {
  const { lang } = useLanguage();
  const [statusKey, setStatusKey] = useState("aboutConnecting");

  useEffect(() => {
    fetch(`${API}/api/test`)
      .then((res) => res.json())
      .then((data) => {
        console.log("About Page:", data);
        setStatusKey("aboutConnectOk");
      })
      .catch((err) => {
        console.error("Error:", err);
        setStatusKey("aboutConnectFail");
      });
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        backgroundColor: "#f0f0f0",
      }}
    >
      <h1 style={{ fontSize: "2.5rem", marginBottom: "20px" }}>
        {t(lang, "aboutTitle")}
      </h1>

      <div
        style={{
          padding: "20px clamp(16px, 6vw, 40px)",
          background: "rgba(255,255,255,0.55)",
          backdropFilter: "blur(20px) saturate(180%)",
          WebkitBackdropFilter: "blur(20px) saturate(180%)",
          border: "1px solid rgba(255,255,255,0.75)",
          borderRadius: "18px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.10), 0 1px 0 rgba(255,255,255,0.8) inset",
        }}
      >
        <h2
          style={{
            fontSize: "1.2rem",
            color: statusKey === "aboutConnectOk"
              ? "green"
              : statusKey === "aboutConnectFail"
              ? "red"
              : "#555",
          }}
        >
          {t(lang, statusKey)}
        </h2>
      </div>
    </div>
  );
}
